import { Category, Module, Store, Zone, StoreType } from "@apis/index";
import ModuleDropdown from "@commons/modules/dropdown";
import Button from "@components/button";
import Column from "@components/column";
import Fields from "@components/fields";
import DropDown from "@components/fields/dropdown";
import Row from "@components/row";
import Wrapper from "@components/wrapper";
import ButtonWrapper from "@components/wrapper/button-wrapper";
import useModulePercentage from "@hooks/useModulePercentage";
import { RootState } from "@store/index";
import { Form, Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  ErrorBox,
  ErrorList,
  ErrorText,
  ErrorTitle,
  FormSection,
  FullWidth,
  UploadSection,
} from "./styles";

const CategoryForm = () => {
  const { infoFields } = useModulePercentage();
  console.log(infoFields, "existing");
  const { data: user } = useSelector((state: RootState) => state.user);
  const { items: stores } = useSelector((state: RootState) => state.stores);
  const [page, setPage] = useState(1);
  const { state } = useLocation();
  console.log(state, "state");
  const navigate = useNavigate();
  const { data: zones } = useSelector((state: RootState) => state.zones);
  const [submitAttempted, setSubmitAttempted] = useState(false);

  const {
    data: storeTypes,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.storeTypes);
  const [initialValues, setInitialValues] = useState<any>({
    module: "",
    category: "",
    title: "",
    show: false,
    image: null as any,
    bannerImage: null as any,
    zoneIds: [] as number[],
    order: "",
    showBanner: "",
    linkType: "link",
    bannerLinks: [] as string[],
    storeIds: [] as any[],
    commission: "",
    showProduct: false,
    typeId: "",
  });

  const fetchCategories = useCallback(async () => {
    await Category.list({ state: "categories", params: { page, parentId: 0 } });
  }, []);

  const fetchModules = async () =>
    await Module.list({ state: "modules", params: { isActive: true } });
  const fetchZones = async (moduleId?: any) =>
    await Zone.list({
      state: "zones",
      params: { moduleId: moduleId || undefined },
    });
  const fetchStores = async (moduleId?: any) =>
    await Store.list({
      state: "stores",
      params: { limit: 3000, moduleId: moduleId || undefined },
    });
  const fetchStoreTypes = async (moduleId?: any) => {
    if (!moduleId) {
      return;
    }
    await StoreType.list({
      state: "storeTypes",
      params: { moduleId, limit: 400000 },
    });
  };

  useEffect(() => {
    fetchModules();
    fetchZones(initialValues.module);
    fetchStores(initialValues.module);
    fetchStoreTypes(initialValues.module);
  }, []);

  useEffect(() => {
    if (!!state || state?.id) {
      let linkType = "link";
      if (state?.banners?.some((banner: any) => banner.storeId)) {
        linkType = "store";
      }

      setInitialValues({
        module: state?.module?.id || "",
        category: state?.name || "",
        title: state?.marketingTitle || "",
        show: !!state?.isShowOnHomeScreen,
        showBanner: !!state?.isShowBannerOnHomeScreen,
        image: state?.icon,
        bannerImage: Array.isArray(state?.banners) ? state.banners : null,
        zoneIds: state?.zones?.map((z: any) => z.id) || [],
        order: state.order,
        linkType: linkType,
        bannerLinks:
          state?.banners?.map((banner: any) => banner.link || "") || [],
        storeIds:
          state?.banners?.map((banner: any) => banner.storeId || "") || [],

        commission:
          typeof state.commission === "object"
            ? state.commission
            : { type: "percent", value: state.commission || "" },
        showProduct: !!state?.showProductOnHomeScreen,
        typeId: state?.typeId || state?.type?.id || "",
      });
      if (state?.module?.id) {
        fetchZones(state.module.id);
        fetchStores(state.module.id);
        fetchStoreTypes(state.module.id);
      }
    } else {
      setInitialValues({
        module: "",
        category: "",
        title: "",
        show: false,
        image: null,
        bannerImage: null,
        zoneIds: [] as number[],
        order: "",
        showBanner: "",
        linkType: "link",
        bannerLinks: [] as string[],
        storeIds: [] as any[],
        commission: { type: "percent", value: "" },
        typeId: "",
      });
    }
  }, [state]);

  const createFormData = (values: typeof initialValues) => {
    const formData = new FormData();
    if (values.module) formData.append("moduleId", String(values.module));
    formData.append("name", values.category);
    formData.append("marketingTitle", values.title);
    formData.append("parentId", "0");
    formData.append("isShowOnHomeScreen", values.show ? "true" : "false");
    formData.append(
      "isShowBannerOnHomeScreen",
      values.showBanner ? "true" : "false",
    );
    formData.append(
      "showProductOnHomeScreen",
      values.showProduct ? "true" : "false",
    );
    if (values.order) formData.append("order", values.order);
    if (values.commission)
      formData.append("commission", JSON.stringify(values.commission));
    formData.append("zoneIds", JSON.stringify(values.zoneIds));
    if (values.typeId) formData.append("typeId", values.typeId);

    if (values.image?.rawFile) {
      formData.append("icon", values.image.rawFile);
    }

    values.bannerImage.forEach((banner, idx) => {
      if (!!state?.id || user?.role != "store") {
        if (banner?.id)
          formData.append(`banners[${idx}][id]`, JSON.stringify(banner.id));
      }
      if (!banner?.id)
        formData.append(`banners[${idx}][image]`, banner.rawFile);
      if (state?.banners?.[idx]?.image) {
        formData.append(`banners[${idx}][oldImage]`, state.banners[idx].image);
      }
      if (values.linkType === "store") {
        formData.append(`banners[${idx}][storeId]`, values.storeIds[idx] || "");
      }
      if (values.linkType === "link") {
        formData.append(`banners[${idx}][link]`, values.bannerLinks[idx] || "");
      }
    });

    return formData;
  };

  const handleSubmit = async (
    values: typeof initialValues,
    { resetForm }: any,
  ) => {
    setSubmitAttempted(true);

    const errors = validateForm(values);

    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach((error: any) => {
        toast.error(error);
      });
      return;
    }

    const formData = createFormData(values);

    const promise = state?.id
      ? Category.update({ state: "categories", id: state.id, data: formData })
      : Category.create({ state: "categories", data: formData });

    await toast.promise(promise, {
      pending: state?.id ? "Updating category..." : "Creating category...",
      success: state?.id
        ? "Category updated successfully!"
        : "Category created successfully!",
      error: "Something went wrong while saving the category.",
    });

    const res = await promise;
    navigate(
      `/admin/product-management/categories?module=${res?.module?.name || "Food"}`,
    );
    resetForm();
    setSubmitAttempted(false); // ✅ Reset submit attempt on success
    await fetchCategories();
  };

  // ✅ Separate validation function
  const validateForm = (values: typeof initialValues) => {
    const errors: any = {};

    // ✅ VALIDATION: At least one banner image is required
    const imageCount = values.bannerImage
      ? Array.isArray(values.bannerImage)
        ? values.bannerImage.length
        : 1
      : 0;

    if (imageCount < 1) {
      errors.bannerImage = "At least one banner image is required";
    }

    // ✅ VALIDATION: Links/storeIds length must match image count
    if (imageCount > 0) {
      if (values.linkType === "store") {
        const storeIdsCount = Array.isArray(values.storeIds)
          ? values.storeIds.length
          : values.storeIds
            ? 1
            : 0;

        if (storeIdsCount > 1 && storeIdsCount !== imageCount) {
          errors.storeIds = `Number of stores (${storeIdsCount}) must match number of images (${imageCount})`;
        }
      } else {
        const bannerLinksCount = Array.isArray(values.bannerLinks)
          ? values.bannerLinks.length
          : values.bannerLinks
            ? 1
            : 0;

        if (bannerLinksCount > 1 && bannerLinksCount !== imageCount) {
          errors.bannerLinks = `Number of links (${bannerLinksCount}) must match number of images (${imageCount})`;
        }
      }
    }

    return errors;
  };

  return (
    <Wrapper stylewrapper="border-radius:12px">
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleSubmit}
        validate={submitAttempted ? validateForm : undefined} // ✅ Only validate after submit attempt
      >
        {({ values, setFieldValue, resetForm, isSubmitting, errors }: any) => (
          <Form>
            <Row>
              <FormSection>
                <Column>
                  <Row>
                    <ModuleDropdown
                      name="module"
                      styleInput="width:95.5%"
                      onChange={(val) => {
                        setFieldValue("module", val);
                        setFieldValue("zoneIds", []);
                        setFieldValue("storeIds", []);
                        setFieldValue("typeId", "");
                        fetchZones(val);
                        fetchStores(val);
                        fetchStoreTypes(val);
                      }}
                    />
                    <Fields.DropDown
                      name="zoneIds"
                      label="Zones"
                      placeholder="---Select Zones---"
                      options={zones}
                      titleAsKey="name"
                      valueAsKey="id"
                      styleInput="width:94.5%"
                      styleOptionsWrapper="width:100%"
                      isMultiple
                      selectable
                      disabled={!values.module}
                    />
                  </Row>

                  <Row>
                    <Fields.Input
                      name="category"
                      placeholder="Enter Category Name"
                      label="Category"
                    />
                    <Fields.DropDown
                      name="order"
                      placeholder="---Select Order---"
                      label="Order"
                      options={Array.from({ length: 15 }, (_, i) => ({
                        id: i + 1,
                        name: (i + 1).toString(),
                      }))}
                      titleAsKey="name"
                      valueAsKey="id"
                      styleInput="width:94.5%"
                    />
                    <div style={{ width: "100%" }}>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "8px",
                          fontWeight: 600,
                          fontSize: "14px",
                          color: "#374151",
                        }}
                      >
                        Commission
                      </label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "stretch",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          overflow: "hidden",
                          height: "48px",
                        }}
                      >
                        <div
                          style={{
                            flex: "0 0 60px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f3f4f6",
                            borderRight: "1px solid #e5e7eb",
                            cursor: "pointer",
                            fontWeight: 600,
                            color:
                              values.commission?.type === "percent"
                                ? "#3b82f6"
                                : "#6b7280",
                            transition: "all 0.2s",
                          }}
                          onClick={() => {
                            const currentType =
                              values.commission?.type || "percent";
                            const newType =
                              currentType === "percent" ? "flat" : "percent";
                            setFieldValue("commission", {
                              ...values.commission,
                              type: newType,
                            });
                          }}
                          title="Click to switch type"
                        >
                          {values.commission?.type === "percent" ? "%" : "Flat"}
                        </div>
                        <div style={{ flex: 1 }}>
                          <Fields.Input
                            name="commission.value"
                            label=""
                            placeholder={
                              values.commission?.type === "percent"
                                ? "10"
                                : "50"
                            }
                            type="number"
                            styleInput="border: none; margin: 0; padding: 0 16px; height: 100%; width: 100%; font-size: 16px; outline: none;"
                            styleWrapper="margin: 0; padding: 0; border: none; height: 100%;"
                          />
                        </div>
                      </div>
                    </div>
                  </Row>

                  <Row styleRow="align-items:center">
                    <Fields.Input
                      name="title"
                      placeholder="Enter Marketing Title"
                      label="Marketing Title"
                    />
                    <Fields.DropDown
                      name="typeId"
                      label="Store Type"
                      placeholder="---Select Store Type---"
                      options={storeTypes}
                      titleAsKey="name"
                      valueAsKey="id"
                      styleInput="width:94.5%"
                      styleOptionsWrapper="width:100%"
                      disabled={!values.module}
                    />
                  </Row>
                  <Row>
                    <Fields.Switch name="show" label="Show on home screen" />
                    <Fields.Switch
                      name="showBanner"
                      label="Show Banner on home screen"
                    />
                    <Fields.Switch
                      name="showProduct"
                      label="Show Product on home screen"
                    />
                  </Row>
                </Column>
              </FormSection>

              <UploadSection>
                <Fields.Upload
                  name="image"
                  height={280}
                  label="Icon Image"
                  useRawFile
                />
              </UploadSection>
            </Row>

            <br />

            <Row>
              <DropDown
                name="linkType"
                label="Banner Link Type"
                options={[
                  { title: "Redirect Link", value: "link" },
                  { title: "Store/Vendor", value: "store" },
                ]}
                titleAsKey="title"
                valueAsKey="value"
                styleInput="width:97%"
                styleOptionsWrapper="width:100%"
                placeholder="Select Link Type"
                onChange={(value) => {
                  setFieldValue("linkType", value);
                  if (value === "link") {
                    setFieldValue("storeIds", []);
                  } else {
                    setFieldValue("bannerLinks", []);
                  }
                }}
              />
              {values.linkType === "store" ? (
                <FullWidth>
                  <DropDown
                    name="storeIds"
                    label="Store"
                    options={stores}
                    titleAsKey="storeName"
                    valueAsKey="id"
                    styleInput="width:97%"
                    styleOptionsWrapper="width:100%"
                    placeholder="Select Store"
                    isMultiple={true}
                    hasSearch
                  />
                  {submitAttempted &&
                    errors.storeIds && ( // ✅ Only show error after submit
                      <ErrorText>{errors.storeIds}</ErrorText>
                    )}
                </FullWidth>
              ) : (
                <FullWidth>
                  <Fields.TagInput
                    allowSame={true}
                    name="bannerLinks"
                    label="Banner Links"
                    placeholder="Enter banner redirect links"
                    icon={false}
                  />
                  {submitAttempted &&
                    errors.bannerLinks && ( // ✅ Only show error after submit
                      <ErrorText>{errors.bannerLinks}</ErrorText>
                    )}
                </FullWidth>
              )}
            </Row>

            <br />

            <div>
              <Fields.Upload
                name="bannerImage"
                height={400}
                label="Banner Image"
                useRawFile
                multiple
                maxFiles={10}
                size={90}
                mode={!!state?.id ? "update" : "create"}
                onRemoveImage={async (val) => {
                  await Category.removeBanner({
                    state: "categories",
                    id: val.id,
                  });
                }}
              />
              {submitAttempted && errors.bannerImage && (
                <ErrorText>{errors.bannerImage}</ErrorText>
              )}
            </div>

            <br />

            {submitAttempted && Object.keys(errors).length > 0 && (
              <ErrorBox>
                <ErrorTitle>Please fix the following errors:</ErrorTitle>
                <ErrorList>
                  {errors.bannerImage && <li>{errors.bannerImage}</li>}
                  {errors.storeIds && <li>{errors.storeIds}</li>}
                  {errors.bannerLinks && <li>{errors.bannerLinks}</li>}
                </ErrorList>
              </ErrorBox>
            )}

            <ButtonWrapper>
              <Button
                title="Reset"
                type="reset"
                variant="reset"
                onClick={() => {
                  resetForm();
                  setSubmitAttempted(false); // ✅ Reset submit attempt on reset
                }}
                disabled={isSubmitting}
              />
              <Button
                title={state?.id ? "Update" : "Save"}
                type="submit"
                disabled={isSubmitting}
              />
            </ButtonWrapper>
          </Form>
        )}
      </Formik>
    </Wrapper>
  );
};

export default CategoryForm;
